<template>
    <el-dialog
        title="装车排序"
        width="35%"
        :visible="true"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="beforeClose"
        :custom-class="'wlLoadSequenceDialog'"
        >
        <el-table
            border
            :data="tableData"
            :height="400"
            :loading="loading"
            :ref="'wlLoadSequenceTable'"
            :row-key="row => row.whCode"
            >
            <el-table-column min-width="40"><i class="el-icon-s-operation"></i></el-table-column>
            <el-table-column label="序号" prop="tableIndex" min-width="40"></el-table-column>
            <el-table-column label="仓库" prop="whName" min-width="300"></el-table-column>
            </el-table>
        <div slot="footer" class="dialog-footer">
            <el-button @click="beforeClose">取 消</el-button>
            <el-button type="primary" @click="handleSubmit" :loading="submitLoading" :disabled="!tableData.length">确 认</el-button>
        </div>
    </el-dialog>
</template>

<script>
import Sortable from 'sortablejs';
import { searchPark, batchUpdateParkSequence } from '../../../../api/basePlatoon';
export default {
    name: 'WlLoadSequence',
    props: {
        realTotalTargetData: {
            type: Array,
            default () {
                return [];
            }
        }
    },
    data () {
        return {
            loading: false,
            submitLoading: false,
            tableData: []
        };
    },
    async mounted () {
        await this.queryWlLoadSequence();
        this.$nextTick(() => {
            this.initSort();
        });
    },
    methods: {
        initSort () {
            const _this = this;
            const tbody = _this.$refs.wlLoadSequenceTable.$el.querySelectorAll('.el-table__body-wrapper >table > tbody')[0];
            Sortable.create(tbody, {
                onEnd: ({ newIndex, oldIndex }) => {
                    const curRow = _this.tableData.splice(oldIndex, 1)[0];
                    _this.tableData.splice(newIndex, 0, curRow);
                    _this.tableData.forEach((item, index) => { item.tableIndex = index + 1; });
                }
            });
        },
        queryWlLoadSequence () {
            this.loading = true;
            const taskNos = this.realTotalTargetData.map(v => v.taskNo);
            searchPark(taskNos)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.tableData = res.data || [];
                        if (this.tableData.length) {
                            this.tableData.forEach((item, index) => { this.$set(item, 'tableIndex', index + 1); });
                        }
                    }
                })
                .catch(() => { })
                .finally(() => { this.loading = false; });
        },
        beforeClose () {
            this.$emit('update:isShowWlLoadSequence', false);
        },
        handleSubmit () {
            this.submitLoading = true;
            batchUpdateParkSequence(this.tableData)
                .then(res => {
                    if (res && +res.code === 0) {
                        this.$message.success('装车排序成功');
                        this.$emit('update:isShowWlLoadSequence', false);
                        this.$emit('updateWlLoadSequence', this.tableData);
                    }
                })
                .catch(() => { })
                .finally(() => {
                    this.submitLoading = false;
                });
        }
    }

};
</script>

<style lang="less">
.wlLoadSequenceDialog {
    .el-table--border {
        border-right: 1px solid #EBEEF5 !important;
        border-bottom: 1px solid #EBEEF5 !important;
    }
}
</style>
